exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.dyBR4PaiOVMEIP1cesMz4{text-align:center;padding:2rem}@media (min-width: 768px){.dyBR4PaiOVMEIP1cesMz4{padding:2rem}}.dyBR4PaiOVMEIP1cesMz4 button{display:block;width:100%}.dyBR4PaiOVMEIP1cesMz4 button+button{margin-top:.5rem}._31eemBF15T1LtcbUrEyRQ9{max-width:72%;margin-top:2rem}\n", ""]);

// exports
exports.locals = {
	"blockScreen": "dyBR4PaiOVMEIP1cesMz4",
	"illustration": "_31eemBF15T1LtcbUrEyRQ9"
};